import {
  FETCH_VIDEO_STORE_ITEMS_START,
  FETCH_VIDEO_STORE_ITEMS_SUCCESS,
  FETCH_VIDEO_STORE_ITEMS_FAILURE,
  FETCH_VIDEO_STORE_SUGGESTIONS_START,
  FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS,
  FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE,
  CHANGE_VIDEO_STORE_VISIBILITY_START,
  CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS,
  CHANGE_VIDEO_STORE_VISIBILITY_FAILURE,
} from "./ActionConstant";

// Trigger fetch of video store items (handled by saga)
// data can include filters, pagination, etc.
export function fetchVideoStoreItemsStart(data) {
  return {
    type: FETCH_VIDEO_STORE_ITEMS_START,
    data,
  };
}

export function fetchVideoStoreItemsSuccess(data) {
  return {
    type: FETCH_VIDEO_STORE_ITEMS_SUCCESS,
    data,
  };
}

export function fetchVideoStoreItemsFailure(error) {
  return {
    type: FETCH_VIDEO_STORE_ITEMS_FAILURE,
    error,
  };
}

// Trigger fetch of video store suggestions (handled by saga)
export function fetchVideoStoreSuggestionsStart(data) {
  return {
    type: FETCH_VIDEO_STORE_SUGGESTIONS_START,
    data,
  };
}

export function fetchVideoStoreSuggestionsSuccess(data) {
  return {
    type: FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS,
    data,
  };
}

export function fetchVideoStoreSuggestionsFailure(error) {
  return {
    type: FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE,
    error,
  };
}

export function changeVideoStoreVisibilityStart(data) {
  return {
    type: CHANGE_VIDEO_STORE_VISIBILITY_START,
    data,
  };
}

export function changeVideoStoreVisibilitySuccess(data) {
  return {
    type: CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS,
    data,
  };
}

export function changeVideoStoreVisibilityFailure(error, request) {
  return {
    type: CHANGE_VIDEO_STORE_VISIBILITY_FAILURE,
    error,
    request,
  };
}


